import React from 'react';
import { Hero } from './components/Hero';
import { SocialProofBar } from './components/SocialProofBar';
import { Testimonials } from './components/Testimonials';
import { PainGrid } from './components/PainGrid';
import { ProductReveal } from './components/ProductReveal';
import { Tomes } from './components/Tomes';
import { Bonuses } from './components/Bonuses';
import { Urgency } from './components/Urgency';
import { Pricing } from './components/Pricing';
import { ValueStack } from './components/ValueStack';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { CostOfInaction } from './components/CostOfInaction';
import { Close } from './components/Close';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
import { shortTestimonials, moreTestimonials } from './data/testimonials';
export function App() {
  return <div className="min-h-screen w-full bg-navy text-white font-sans selection:bg-gold selection:text-gold-ink" data-id="element-0" data-mp="23w4e5zrtp20b">
      <MetaPixel data-id="element-1" data-mp="3iiwasc8k4vxf" />
      <main data-id="element-2" data-mp="3ijftvw9y1qd1">
        <Hero data-id="element-3" data-mp="3ihv048vgebg8" />
        <SocialProofBar data-id="element-4" data-mp="3mlj9mx3nbh44" />
        <PainGrid data-id="element-5" data-mp="3ml17xky7saot" />
        <ProductReveal data-id="element-6" data-mp="3mkhofzsx1e8o" />
        <Tomes data-id="element-7" data-mp="3mjq3diwy2ywn" />
        <Bonuses data-id="element-8" data-mp="3mj6hxs835sdv" />
        <ValueStack data-id="element-9" data-mp="3rcj6k2crlz6m" />
        <Urgency data-id="element-10" data-mp="3rbznujfaj6rj" />
        <Pricing data-id="element-11" data-mp="3rdkh85pvcjnt" />
        <Testimonials testimonials={shortTestimonials} background="white" data-id="element-12" data-mp="3rd191gq0t9mz" />
        <Guarantee data-id="element-13" data-mp="4n5i12o8na1" />
        <Faq data-id="element-14" data-mp="56m9egl55mh" />
        <Testimonials testimonials={moreTestimonials} title="More coaches, more seasons" background="cream" data-id="element-15" data-mp="7sulgbavp5r" />
        <CostOfInaction data-id="element-16" data-mp="33nq6btp41567" />
        <Close data-id="element-17" data-mp="33n6wz1dizp3s" />
      </main>
      <Footer data-id="element-18" data-mp="33oi152avuyvf" />
    </div>;
}